import type { LineItem } from "@/interfaces/estimate-detail";
import { cn } from "@/lib/utils";
import { capitalizeWords } from "@rebuild/shared";
import type { ReactNode } from "react";
import { useCallback } from "react";
import type { Category } from "../estimation-details/Rooms/Lines";

export type FilterOptionType = {
  id: string;
  value: string;
  icon?: ReactNode;
  customValue?: string;
  category?: Category;
  lineItem?: LineItem;
  fileName?: string;
  pageIndex?: number;
  isUnassignedOrMappedByUser?: boolean;
};

interface FilterOptionProps {
  option: FilterOptionType;
  selected: boolean;
  onClick: (option: FilterOptionType) => void;
}

export const FilterOption = ({ option, selected, onClick }: FilterOptionProps) => {
  const onOptionClick = useCallback(() => {
    onClick(option);
  }, [onClick, option]);

  const tabText = option.isUnassignedOrMappedByUser ? `Unassigned - ${capitalizeWords(option.value)}` : capitalizeWords(option.value);

  return (
    <div
      onClick={onOptionClick}
      className={cn(
        // Uncomment this to see the original filter option
        "inline-flex h-6 cursor-pointer rounded-lg px-1 py-1 text-[#71717A] transition-all duration-300",
        "flex items-center justify-between gap-1",
        // 'h-6 rounded-lg cursor-pointer px-1 py-1 inline-flex text-[#71717A] transition-all duration-300',
        // 'flex justify-between items-center gap-1 bg-white border border-gray-200 mr-1',
        {
          "bg-[#F4F4F5] px-2 text-black": selected,
        },
      )}
    >
      {option.icon && option.icon}

      <p className={`!font-medium whitespace-nowrap ${option.isUnassignedOrMappedByUser && "italic"}`}>{tabText}</p>
    </div>
  );
};
